export const enum FontColor {
    Dark = '#333333',
    Black = '#052F41',
    White = '#FFFFFF',
    BlueDark = '#2f4f75',
    Pink600 = '#ff507f',
    Primary = '#4ec2cf',
}
